import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const revokeScimToken = api(async function revokeScimToken({ id, clientId } = {}) {
    return await mutate(
        gql`
            mutation revokeScimToken($id: String!, $clientId: String) {
                revokeScimToken(id: $id, clientId: $clientId)
            }
        `,
        { id, clientId },
        { returns: "revokeScimToken" }
    )
})
